import React, { memo, useCallback } from "react";
import moment from "moment";
import toast from "react-hot-toast";
import Status from "../../../../Utils/Status/Status";
import "./List.css";

const fmt = require("indian-number-format");

const formatNumber = (num) => {
  const val = parseFloat(num);
  return isNaN(val) ? "0" : fmt.format(val.toFixed(0));
};
function ListCard({ item, userType }) {
  const {
    id,
    name,
    username,
    master_username,
    super_username,
    commission_weekly,
    commission_total,
    profit_loss,
    net_profit_loss,
    trade,
    only_sq,
    status,
    ip,
    date_created,
    last_login_date,
  } = item;

  const handleSuperEdit = useCallback(() => {
    window.user_id = item.super_id;
    window.openeditSuper?.();
  }, [item.super_id]);

  const handleMasterEdit = useCallback(() => {
    window.user_id = item.master_id;
    window.masterModalOpen?.();
  }, [item.master_id]);

  const handleBrokerEdit = useCallback(() => {
    window.user_id = item.id;
    window.brokerModalOpen?.();
  }, [item.id]);

  const handleCopyMsg = () => {
    const msg = `
Welcome To ${window.APP_NAME}

Name : ${name}  
User Username : ${username}
User Password : ${"123123" || "*****"}

Platform: ${window.WEBSITE_LINK}`;

    navigator.clipboard.writeText(msg);
    toast.success("Copied user message");
  };

  const profitLossClass = profit_loss > 0 ? "buytext" : "selltext";
  const profitLossNetClass = net_profit_loss > 0 ? "buytext" : "selltext";

  return (
    <div onDoubleClick={handleCopyMsg} className="menuContainer addHight text">
      {userType === 1 && (
        <div
          onClick={handleSuperEdit}
          className={`menuUsername ${userType === 1 ? "small" : null} `}
        >
          <div className="user_id">{super_username}</div>
        </div>
      )}

      {(userType === 1 || userType === 2) && (
        <div
          onClick={handleMasterEdit}
          className={`menuUsername ${userType === 1 ? "small" : null} `}
        >
          <div className="user_id">{master_username}</div>
        </div>
      )}

      <div onClick={handleBrokerEdit} className={`menuUsername small`}>
        <div className="user_id">{username}</div>
      </div>
      <div className={`menuName  ${profitLossClass}`}>
        {formatNumber(Math.abs(profit_loss))}
      </div>

      <div className={`menuName ${profitLossNetClass}`}>
        {formatNumber(Math.abs(net_profit_loss))}
      </div>

      <div className="menuName buytext">{formatNumber(commission_weekly)}</div> 

      <div className="menuName buytext">{formatNumber(commission_total)}</div> 

      <div className="menuName">
        <Status id={id} status={trade} type="TRADE" />
      </div>
      <div className="menuName">
        <Status id={id} status={only_sq} type="ONLY_SQ" />
      </div>
      <div className="menuName">
        <Status id={id} status={status} type="STATUS" />
      </div>

      <div className="menuName small">{ip || "N/A"}</div>

      <div className="menuDate flex flex-col items-center justify-center">
        <div className="extraSmall">
          {moment(date_created).format("DD-MM-YYYY")}
        </div>
        <div className="small">{moment(date_created).format("HH:mm:ss")}</div>
      </div>

      <div className="menuDate small flex flex-col items-center justify-center">
        {last_login_date ? (
          <>
            <div className="extraSmall">
              {moment(last_login_date).format("DD-MM-YYYY")}
            </div>
            <div className="small">
              {moment(last_login_date).format("HH:mm:ss")}
            </div>
          </>
        ) : (
          "N/A"
        )}
      </div>

      {/* <div className="menuDate small">{formatDate(last_login_date)}</div> */}

      <div className="menuName">
        <button
          onClick={handleBrokerEdit}
          className={`bg-[var(--primary)] relative flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 cursor-pointer hover:opacity-80 text-white border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)]`}
        >
          EDIT
        </button>
      </div>
    </div>
  );
}

export default memo(ListCard);
